import { connect } from "react-redux";

import Breadcrumbs from "../components/breadcrumbs";

export default (segmentDefinitions) => {
  const mapStateToProps = (state) => {
    const focusView = state.navigation.focusView;
    const segments = segmentDefinitions.map(([focusViewKey, clickHandler, terminalBool]) => {
      return {
        focusViewObject: focusView[focusViewKey],
        onClick: clickHandler,
        terminal: terminalBool
      };
    });

    return { segments };
  };

  const mapDispatchToProps = dispatch => ({
    segmentClick: mappedActionCreator => mappedActionCreator(dispatch)()
  });

  return connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
};
